import {
  OPERATOR_TYPES_1,
  OPERATOR_TYPES_6,
} from 'dashboard/components/widgets/FilterInput/FilterOperatorTypes.js';

const NO_VALUE_OPERATORS = [
  { value: 'is_present', label: 'Is present' },
];

const filterTypes = [
  {
    attributeKey: 'board_id',
    attributeI18nKey: 'BOARDS',
    inputType: 'search_select',
    dataType: 'text',
    filterOperators: OPERATOR_TYPES_6,
    attribute_type: 'standard',
  },
  {
    attributeKey: 'assignee_id',
    attributeI18nKey: 'ASSIGNEE_NAME',
    inputType: 'search_select',
    dataType: 'text',
    filterOperators: OPERATOR_TYPES_6,
    attribute_type: 'standard',
  },
  {
    attributeKey: 'labels_id',
    attributeI18nKey: 'LABEL_NAME',
    inputType: 'search_select',
    dataType: 'text',
    filterOperators: OPERATOR_TYPES_6,
    attribute_type: 'standard',
  },
  {
    attributeKey: 'check_lead_quality',
    attributeI18nKey: 'CHECK_LEAD_QUALITY',
    inputType: null,
    dataType: 'text',
    filterOperators: NO_VALUE_OPERATORS,
    attribute_type: 'standard',
  },
  {
    attributeKey: 'send_conversion_event',
    attributeI18nKey: 'SEND_CONVERSION_EVENT',
    inputType: 'search_select',
    dataType: 'text',
    filterOperators: OPERATOR_TYPES_1,
    attribute_type: 'standard',
  },
  {
    attributeKey: 'send_ai_generated_email',
    attributeI18nKey: 'SEND_AI_GENERATED_EMAIL',
    inputType: 'ai_generated_email',
    dataType: 'text',
    filterOperators: OPERATOR_TYPES_1,
    attribute_type: 'standard',
  },
];

/** Actions where the operator dropdown is hidden (only attribute + optional value). */
export const ACTION_KEYS_HIDE_OPERATOR = [
  'check_lead_quality',
  'send_conversion_event',
  'send_ai_generated_email',
];

export const ACTION_KEYS_WITHOUT_VALUES = ['check_lead_quality'];

export const actionAttributeGroups = [
  {
    name: 'Standard Filters',
    i18nGroup: 'STANDARD_FILTERS',
    attributes: [
      {
        key: 'assignee_id',
        i18nKey: 'ASSIGNEE_NAME',
      },
      {
        key: 'labels_id',
        i18nKey: 'LABEL_NAME',
      },
      {
        key: 'board_id',
        i18nKey: 'BOARDS',
      },
    ],
  },
  {
    name: 'Contact Actions',
    i18nGroup: 'CONTACT_ACTIONS',
    attributes: [
      {
        key: 'check_lead_quality',
        i18nKey: 'CHECK_LEAD_QUALITY',
        featureFlag: 'lead_quality',
      },
      {
        key: 'send_conversion_event',
        i18nKey: 'SEND_CONVERSION_EVENT',
        featureFlag: 'meta_conversion_board_sync',
      },
      {
        key: 'send_ai_generated_email',
        i18nKey: 'SEND_AI_GENERATED_EMAIL',
      },
    ],
  },
];

export default filterTypes;
